<template>
  <div class="mx-auto w-[min(1200px,calc(100vw-48px))] animate-pulse max-[799px]:w-[768px]">
    <!-- 详情客户端请求完成前展示骨架屏，避免先出现 404 或空内容。 -->
    <div class="flex h-[70px] items-center space-x-[8px] py-[16px]">
      <div class="h-[16px] w-[60px] rounded-[8px] bg-[#e4e6eb]"></div>
      <div class="h-[12px] w-[12px] rounded-[8px] bg-[#e4e6eb]"></div>
      <div class="h-[16px] w-[120px] rounded-[8px] bg-[#e4e6eb]"></div>
      <div class="h-[12px] w-[12px] rounded-[8px] bg-[#e4e6eb]"></div>
      <div class="h-[16px] w-[80px] rounded-[8px] bg-[#e4e6eb]"></div>
    </div>

    <div class="pb-[113px]">
      <div
        class="flex flex-col space-y-[24px] bg-[#F5F6F8] min-[1248px]:flex-row min-[1248px]:space-y-[0] min-[1248px]:space-x-[24px]"
      >
        <div
          class="flex w-full shrink-0 flex-col space-y-[24px] rounded-[12px] bg-[#FFF] p-[24px] min-[1248px]:w-[792px]"
        >
          <div class="flex items-center justify-between">
            <div class="flex items-center space-x-[8px]">
              <div class="h-[40px] w-[40px] rounded-[8px] bg-[#e4e6eb]"></div>
              <div class="flex flex-col space-y-[4px]">
                <div class="h-[16px] w-[80px] rounded-[8px] bg-[#e4e6eb]"></div>
                <div class="h-[12px] w-[60px] rounded-[8px] bg-[#e4e6eb]"></div>
              </div>
            </div>
            <div class="h-[26px] w-[64px] rounded-[8px] bg-[#e4e6eb]"></div>
          </div>

          <div class="flex flex-col space-y-[8px]">
            <div class="h-[18px] w-full rounded-[8px] bg-[#e4e6eb]"></div>
            <div class="h-[18px] w-[90%] rounded-[8px] bg-[#e4e6eb]"></div>
            <div class="h-[18px] w-[40%] rounded-[8px] bg-[#e4e6eb]"></div>
          </div>

          <div class="flex flex-col space-y-[8px]">
            <div class="h-[1px] w-full bg-[#e4e6eb]"></div>
            <div class="h-[16px] w-[120px] rounded-[8px] bg-[#e4e6eb]"></div>
          </div>

          <div class="h-[500px] w-full rounded-[8px] bg-[#e4e6eb]"></div>

          <div class="flex items-center justify-between pt-[8px]">
            <div class="flex items-center space-x-[4px]">
              <div class="h-[14px] w-[14px] rounded-[8px] bg-[#e4e6eb]"></div>
              <div class="h-[14px] w-[80px] rounded-[8px] bg-[#e4e6eb]"></div>
            </div>
            <div class="h-[14px] w-[40px] rounded-[8px] bg-[#e4e6eb]"></div>
          </div>

          <div class="h-[42px] w-full rounded-[8px] bg-[#e4e6eb]"></div>

          <div class="flex w-full items-center justify-between border-t border-solid border-[#f4f4f4] pt-[16px]">
            <div class="flex flex-col space-y-[4px]">
              <div class="h-[12px] w-[40px] rounded-[8px] bg-[#e4e6eb]"></div>
              <div class="h-[16px] w-[150px] rounded-[8px] bg-[#e4e6eb]"></div>
            </div>
            <div class="flex flex-col items-end space-y-[4px]">
              <div class="h-[12px] w-[40px] rounded-[8px] bg-[#e4e6eb]"></div>
              <div class="h-[16px] w-[150px] rounded-[8px] bg-[#e4e6eb]"></div>
            </div>
          </div>

          <div class="flex items-center rounded-[8px] border border-solid border-[#e4e6eb] p-[16px]">
            <div class="mr-[8px] h-[32px] w-[32px] shrink-0 rounded-[8px] bg-[#e4e6eb]"></div>
            <div class="h-[16px] w-[120px] rounded-[8px] bg-[#e4e6eb]"></div>
            <div class="flex-1"></div>
            <div class="h-[22px] w-[60px] rounded-[8px] bg-[#e4e6eb]"></div>
          </div>
        </div>

        <div class="flex flex-col space-y-[24px] min-[1248px]:w-[384px]">
          <div class="flex h-[156px] w-full flex-col space-y-[16px] rounded-[8px] bg-[#FFF] p-[24px]">
            <div class="h-[24px] w-[150px] rounded-[8px] bg-[#e4e6eb]"></div>
            <div class="h-[44px] w-full rounded-[8px] bg-[#e4e6eb]"></div>
          </div>
          <div class="flex h-[450px] w-full flex-col space-y-[16px] rounded-[8px] bg-[#FFF] p-[24px]">
            <div class="h-[24px] w-[120px] rounded-[8px] bg-[#e4e6eb]"></div>
            <div class="flex flex-col space-y-[12px]">
              <div v-for="i in 5" :key="i" class="flex items-center space-x-[12px] py-[8px]">
                <div class="h-[32px] w-[32px] rounded-[8px] bg-[#e4e6eb]"></div>
                <div class="flex flex-1 flex-col space-y-[4px]">
                  <div class="h-[14px] rounded-[8px] bg-[#e4e6eb]"></div>
                  <div class="h-[12px] w-[50%] rounded-[8px] bg-[#e4e6eb]"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
